<template>
    <base-radio-input
        v-model="button"
        ref="base-radio-input"
        :name="name"
        :value="value"
        :disabled="disabled"
        input-hidden
        class="mr-2 text-center"
    >
        <template>
            <base-button :large="large"
                         :small="small"
                         :disabled="disabled"
                         block pill
                         color="light"
                         @click="$emit('change', value)">
                <slot/>
            </base-button>
        </template>
        <template #checked>
            <base-button :large="large"
                         :small="small"
                         :disabled="disabled"
                         block pill
                         @click="$emit('change', value)">
                <slot/>
            </base-button>
        </template>
    </base-radio-input>
</template>

<script>
import BaseButton from "../BaseButton";
import BaseRadioInput from "../BaseRadioInput";

export default {
    name: "BaseRadioInputButton",
    components: {BaseRadioInput, BaseButton},
    model: {
        prop: 'selectedButton',
        event: 'change'
    },
    props: {
        disabled: Boolean,
        name: String,
        selectedButton: Number | String,
        value: Number | String,
        large: Boolean,
        small: Boolean,
    },
    computed: {
        button: {
            get() {
                return this.selectedButton;
            },

            set(value) {
                this.$emit('change', value);
            }
        },
    },
}
</script>
